var ShopsComponent;

(function ($, utils) {

	var ShopsSliderComponent = Vue.component('shops-slider-vue', {
		template: '#shops-slider-vue',
		props: ['catId', 'category', 'showTooltip']
	});

	var ShopsCategoryComponent = Vue.component('shops-category-vue', {
		template: '#shops-category-vue',
		props: ['catId', 'category', 'showTooltip']
	});

	var ShopsPreviewComponent = Vue.component('shops-preview-vue', {
		template: '#shops-preview-vue',
		props: ['cats', 'values', 'showTooltip', 'changeView'],
		data: function() {
			return {
				catId: 0,
				category: ''
			}
		},
		methods: {
			showSlider: function(id) {
				this.category = this.values.filter(function(el) {
					return id === el.catId;
				})[0];
			}
		}
	});

	var ShopsDetailComponent = Vue.component('shops-detail-vue', {
		template: '#shops-detail-vue',
		props: ['action', 'closeDetail']
	});


	var ShopsListComponent = Vue.component('shops-list-vue', {
		template: '#shops-list-vue',
		props: ['list', 'changeView', 'showTooltip']
	});

	var ShopsSearchComponent = Vue.component('shops-search-vue', {
		template: '#shops-search-vue',
		props: ['filtered', 'changeView', 'showTooltip', 'result']
	});

	ShopsComponent = Vue.component('shops-vue', {
		template: '#shops-vue',
		data: function() {
			return {
				id: '',
				storeFloor: '',
				hideBtn: false,
				viewType: 'preview',
				values: [],
				cats: [],
				list: [],
				search: [],
				result: false,
				filtered: [],
				switchData: [
					{ view: 'preview', text: 'Категории'},
					{ view: 'list', text: 'Список'}
				],
				action: [],
				hideSpinner: false
			}
		},
		components: {
			ShopsPreviewComponent: ShopsPreviewComponent,
			ShopsListComponent: ShopsListComponent,
			ShopsSliderComponent: ShopsSliderComponent,
			ShopsCategoryComponent: ShopsCategoryComponent,
			ShopsSearchComponent: ShopsSearchComponent,
			ShopsDetailComponent: ShopsDetailComponent,
		},

		mounted: function() {
			this.mobile();
		},

		methods: {
			mobile: function() {
				var that = this,
					$box = $('.box_blockShops'),
					$detailShops = $('.blockShopsDetail'),
					$search = $box.find('.search'),

					isMobile = function() {
					if (app.sizes.width < app.mobileTo) {
						that.switchData = [{view: 'preview', text: 'Магазины', icon: 'shops'}, {view: 'list', text: 'Список', icon:'list'}];
						$('.blockShops__animate').prepend($search);
						$search.addClass('fade-item');
						$('.content').append($detailShops);
					} else {
						that.switchData = [{view: 'preview', text: 'Категории'}, {view: 'list', text: 'Список'}];
						$('.blockShops__right .blockShops__wrapp').append($search);
						$search.removeClass('fade-item');
					}
				};

				isMobile();
			},

			gotoMap: function() {
				var arr = {
					id: '',
					floor: ''
				};
				arr.id = this.id;
				arr.floor = this.storeFloor;
				return arr;
			},

			getDataArr: function(storeId, floor) {
				this.id   = storeId;
				this.storeFloor  = floor;
			},

			showTooltip: function(catIndex, storeId, floor) {
				vueApp.$refs.shops.getDataArr(storeId, floor);

				// todo потестить, потом код в комментах удалить
				this.action = this.list[catIndex].stores.filter(function(el) {
					return storeId === el.id;
				})[0];

				//var that = this;

				//this.list.forEach(function(el) {
				//  el.stores.forEach(function(el) {
				//    if(el.id === storeId)
				//    	that.action = el;
				//  })
				//});

				/*temp.action = el.stores.filter(function(el) {
					 return storeId === el.id;
				 })[0];*/
			},

			doSearch: CommonHelpers.debounce(function(str) {
				if(this.list.length) {
					var filtered = [],
						result = false;

					str = str.trim().toLowerCase();

					$.each(this.list, function(catIndex, cat) {
						var stores = [];

						filtered.push({
							catName: cat.catName,
							typeName: cat.typeName
						});

						$.each(cat.stores, function(storeIndex, store) {
							if(store.storeName) {
								var indexStr = store.storeName.toLowerCase().indexOf(str, 0);

								if (indexStr > -1 && indexStr <= 0) {
									stores.push(store);
									result = true;
								}
							}
						});

						$.extend(filtered[catIndex], {stores: stores});
					});

					this.filtered = filtered;
					this.result = result;
				}

				this.viewType = 'search';

				this.$nextTick(function() {
					// Инит скролера для поиска
					this.scrollerInit('search');
					if (app.sizes.width < app.mobileTo) this.scriptsInit();
				});
			}, 300),

			changeView: function(type) {
				this.viewType = type;

				var that = this;

				if (type == 'preview') this.search = [];

				var isMobile = function() {
					if (app.sizes.width < app.mobileTo) {

						var $categoryList = $('.box_blockShops .categoryList');

						if (type == 'list') {

							if (!$categoryList.hasClass('open')) {
								$('html, body').animate({
									scrollTop: $('.box_blockShops').offset().top - $('.header__left').outerHeight()
									}, 500, function(){
										$('html, body').addClass('overflow--list');
								});
							}

							$(window).on('resize', function(){
								if (that.viewType == 'list' || that.viewType == 'search') {
									$('html, body').removeClass('overflow--list').animate({
										scrollTop: $('.box_blockShops').offset().top - $('.header__left').outerHeight()
										}, 0, function(){
											$('html, body').addClass('overflow--list');
									});
								}
							});

						} else {
							$('html, body').removeClass('overflow--list');
							$(window).scrollTop($('.box_blockShops').offset().top - $('.header__left').outerHeight());

							$categoryList.fadeOut(500, function(){
								$(this).removeClass('open');
							});
						}
					}
				};
				isMobile();
			},

			getData: function() {
				var url = '/static/components-assets/blockShops/data.json';

				if(CommonHelpers.isDev('gold-babylon-static.denode.ru'))
					url = 'static/components-assets/blockShops/data.json';
					url = 'static/components-assets/blockShops/data.json';

				if(!this.values.length) {
					this.$http
						.get(url, {
							params: {
								action: 'getShops'
							}
						})
						.then(function(response) {
							var data = response.body.data;
							this.values = response.body.data;

							var that = this;

							var cats = [],
								block0 = [],
								block1 = [],
								block2 = [],
								block3 = [];

							var list = [],
									catType = [];

							var objImages = []; // массив со ссылками изображений мозайки

								// имя категории
								$(data).each(function(i, el) {
									var newObj = {
										loaded: false,
										src: el.catImg
									};

									objImages.push(newObj);

									// подкатегория
									if (el.types.length == 0) {
										el.class = 'empty';
									} else {
										$(el.types).each(function(i, type) {
											var stores = [];
											catType = type.typeName,
											typeId = type.typeId;

											// магазины
											$(type.stores).each(function(i, store) {
												stores.push(store);
											});

											list.push({
												typeId: typeId,
												catName: el.catName,
												typeName: catType,
												stores: stores
											});
										});
									}

									if(i >= 0 && i <= 1)
										block0.push(el);

									if(i >= 2 && i <= 4)
										block1.push(el);

									if(i >= 5 && i <= 7)
										block2.push(el);

									if(i >= 8 && i <= 9)
										block3.push(el);
								});

								if(block0)
									cats.push({className: 'mosaic__block', items: block0});

								if(block1)
									cats.push({className: 'mosaic__block mosaic__block_trinity', items: block1});

								if(block2)
									cats.push({className: 'mosaic__block mosaic__block_trinity', items: block2});

								if(block3)
									cats.push({className: 'mosaic__block mosaic__block_horizont', items: block3});

								this.list = list;
								this.cats = cats;

							// Переход к карте в тултипе
							var $gotoMap = $('.box_blockShops').find('.js-gotoMap');
							$gotoMap.on('click', function() {
								var arr = vueApp.$refs.shops.gotoMap();
								CommonHelpers.searchMap(null, arr);
							});

							CommonHelpers.checkImgLoading(objImages)
								.then(function() {
									that.doAnimation();
								});

								this.$nextTick(function() {
									this.scriptsInit();
								});
							},
							function(response) { // Error.
								console.log('An error occurred.');
							}
						);
				}
			},

			doAnimation: function() {
				var $targetSlide;

				if (app.sizes.width < app.mobileTo) {

					$targetSlide = $('.tileBlock');
					$('.box_blockShops .search').showItem(450);

				} else $targetSlide = $('.mosaic');

				$targetSlide.find('.fade-button').showItem(150);

				this.hideSpinner = true;
			},

			scrollerInit: function(type) {
				type = type || '';

				var $box            = $('.box_blockShops'),
						$left           = $box.find('.blockShops__left'),
						$scroller       = $left.find('[data-view="' + type + '"] .js-custom-scroll'),
						$prev           = $left.find('[data-view="' + type + '"] .js-prev-scroll'),
						$next           = $left.find('[data-view="' + type + '"] .js-next-scroll');

				//$scroller.mCustomScrollbar('destroy');
				if (app.sizes.width > app.mobileTo) app.utils.scroller($scroller, $prev, $next, $left); // кастомный скролл выключить для мобил
			},

			closeDetail: function() {
				$('.blockShopsDetail').removeClass('open');
				$('html, body').removeClass('overflow--detail');
				$(window).scrollTop($('.box_blockShops').offset().top - $('.header__left').outerHeight());
			},

			scriptsInit: function(list) {
				var $box            = $('.box_blockShops'),
						$detailBlock    = $('.blockShopsDetail'),
						$inner          = $detailBlock.find('.blockShopsDetail__inner'),
						$left           = $box.find('.blockShops__left'),
						$tooltip        = $box.find('.tooltip'),
						$categorySlider = $box.find('.categorySlider'),
						$closeCategory  = $categorySlider.find('.close'),
						$mosaic         = $box.find('.mosaic'),
						$tileBlock      = $box.find('.tileBlock'),
						$catMore        = $box.find('.js-catMore'),
						$contentMore    = $box.find('.tileBlock__content'),
						$categoryList   = $box.find('.categoryList'),
						$categoryListWrapp = $categoryList.find('.categoryList__wrapp')
						$closeCat = $categoryList.find('.js-close'),
						$items = $box.find('.blockList__item'),
						that = this;

				// Инит скролера для списка
				this.scrollerInit('list');

				var isMobile = function() {
					if (app.sizes.width < app.mobileTo) {

						$items.on('click', function(){
							$('html, body').addClass('overflow--detail');
							$detailBlock.addClass('open');
							$inner.scrollTop(0);
						});

						var detail = document.getElementById('blockShopsDetail');
						var mc = new Hammer(detail);

						mc.on('swiperight', function() {
							that.closeDetail();
						});

						$tileBlock.on('click', '.tileBlock__item', function() {
							if (!$(this).hasClass('empty')) {

								$('body,html').animate({
									scrollTop: $('.box_blockShops').offset().top - $('.header__left').outerHeight()
								}, 500, function(){
									$('html, body').addClass('overflow--list');
								});

								$(window).on('resize', function(){
									if ($categoryList.hasClass('open')) {
										$('html, body').removeClass('overflow--list').animate({
											scrollTop: $('.box_blockShops').offset().top - $('.header__left').outerHeight()
											}, 0, function(){
												$('html, body').addClass('overflow--list');
										});
									}
								});

								$categoryList.fadeIn(500, function() {
									var $items = $(this).find('.blockList__item');

									$(this).addClass('open');

									$items.on('click', function(){
										$('html, body').addClass('overflow--detail');
										$detailBlock.addClass('open');
										$inner.scrollTop(0);
									});

									$closeCat.on('click', function() {
										$categoryList.fadeOut(500, function(){
											$('html, body').removeClass('overflow--list');
											$(window).scrollTop($('.box_blockShops').offset().top - $('.header__left').outerHeight());
											$(this).removeClass('open');
										});
									});
								});
							}
						});

						$catMore.on('click', function(){
							$contentMore.fadeIn(500, function(){
								$catMore.fadeOut(100);
							});
						});

					} else {
						app.utils.tooltip($tooltip, '.box_blockShops .blockShops__left');

						$mosaic.on('click', '.mosaic__item', function() {
							if (!$(this).hasClass('empty')) {
								$left.addClass('active');
								$categorySlider.fadeIn(400, function() {

									var that = this,
										$slides = $(that).find('.swiper-slide'),
										$pagination = $(that).find('.swiper-pagination'),
										$bullets = $pagination.find('.swiper-pagination-bullet');

									var swiper = new Swiper('.categorySlider .swiper-container', {
										loop: false,
										nextButton: '.categorySlider .swiper-button-next',
										prevButton: '.categorySlider .swiper-button-prev',
										effect: 'fade',
										onInit: function(swiper){
											var index = swiper.activeIndex,
												$bulletCurr = $bullets.eq(swiper.activeIndex);

											$bullets.removeClass('active');
											if (!$bulletCurr.hasClass('active')) {
												$bulletCurr.addClass('active');
											}

											$bullets.on('click', function(){
												var $bullet = $(this),
													index = $bullet.index();

												$bullets.removeClass('active');
												if (!$bullet.hasClass('active')) {
													$bullet.addClass('active');
												}
												swiper.slideTo(index, 400, true);
											});

											$.each($slides, function(){
												$(this).mCustomScrollbar({
													axis: 'x'
												});
												$(this).on('mousewheel', function(event) {
													event.stopPropagation();
												});
											});
										},
										onSlideChangeStart: function(swiper){
											var index = swiper.activeIndex,
												$bulletCurr = $bullets.eq(swiper.activeIndex);

											$bullets.removeClass('active');
											if (!$bulletCurr.hasClass('active')) {
												$bulletCurr.addClass('active');
											}
										}
									});
								});
							}
						});

						$closeCategory.on('click', function() {
							$categorySlider.fadeOut(400, function() {
								$left.removeClass('active');
							});
						});
					}
				};
				isMobile();
			}
		}
	});
})(jQuery, app.utils);
